export const createUpdateCacheKey = (webhookId: string) =>
  `patch-webhook-${webhookId}`;

export const createValidationEndpointCacheKey = (url: string) =>
  `validating-url-${url}`;
